import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { COORDINATOR } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { selectChangeSlaId } from 'AppSrc/core/components/forms/form-types/create-crq/section-two/section-two-constants';

const fieldId = selectChangeSlaId;

const validator = (params) => {
  const {
    values,
    field,
    role,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);
  // This is defaulted to null from requestors, but for coordinators they must set it as a value
  // NOTE: Whilst this works perfectly, if this was a multiselect option this would always fail
  const nullValueCoordinator = (values[fieldId].includes(null) && role === COORDINATOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  errors[INLINE_ERRORS].push((nullValueCoordinator && !optional) ? 'Please select an option' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};



const initialValues = [];

const vFParams = {
  multiSelect: false,
  displayType: 'big',
  fieldTitle: 'Select change SLA',
};

const selectChangeSla = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { selectChangeSla };
